module.exports = __webpack_public_path__ + "media/soundtrack.1d068fcc.mp3";